{
  "corpusVersion": "sha256:8c8b3c8e7d5ced651152521afc2e7a92720bc6bc45ebbc14abe66be7c0190b66",
  "diagnostics": [
    {
      "prompt": "tense spy drama",
      "resultCount": 49,
      "status": "kept",
      "surface": "homepageHero",
      "topScore": 0.6286793279374335,
      "topSlug": "betrayal-2026"
    },
    {
      "prompt": "character-first mysteries",
      "resultCount": 20,
      "status": "kept",
      "surface": "homepageHero",
      "topScore": 0.545820413924303,
      "topSlug": "the-marlow-murder-club-2024"
    },
    {
      "prompt": "90s-style sitcom",
      "resultCount": 13,
      "status": "kept",
      "surface": "homepageHero",
      "topScore": 0.4997669028682546,
      "topSlug": "adults-2025"
    },
    {
      "prompt": "warm workplace comedy",
      "resultCount": 40,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.6284471428740496,
      "topSlug": "not-suitable-for-work-2026"
    },
    {
      "prompt": "dark comedy about loss",
      "resultCount": 25,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.5859140601025336,
      "topSlug": "shrinking-2023"
    },
    {
      "prompt": "country-house intrigue",
      "resultCount": 14,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.5391327349060154,
      "topSlug": "the-party-2026"
    },
    {
      "prompt": "murder mystery small town",
      "resultCount": 50,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.5712243856680543,
      "topSlug": "the-marlow-murder-club-2024"
    },
    {
      "prompt": "slow-burn conspiracy thriller",
      "resultCount": 34,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.5527146591636869,
      "topSlug": "inside-the-circle-2026"
    },
    {
      "prompt": "character-first mystery",
      "resultCount": 15,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.5144245970028231,
      "topSlug": "the-marlow-murder-club-2024"
    },
    {
      "prompt": "sharp workplace comedy",
      "resultCount": 38,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.611499342101414,
      "topSlug": "not-suitable-for-work-2026"
    },
    {
      "prompt": "atmospheric supernatural drama",
      "resultCount": 31,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.5496691985415014,
      "topSlug": "agent-from-above-2026"
    }
  ],
  "generatedAt": "2026-11-03T12:53:42.683Z",
  "minScore": 0.44,
  "prompts": {
    "homepageHero": [
      "tense spy drama",
      "character-first mysteries",
      "90s-style sitcom"
    ],
    "homepageLowerPromo": [
      "warm workplace comedy",
      "dark comedy about loss",
      "country-house intrigue",
      "murder mystery small town"
    ],
    "shows-like-bottom": [
      "slow-burn conspiracy thriller",
      "character-first mystery",
      "sharp workplace comedy",
      "atmospheric supernatural drama"
    ]
  },
  "version": 1
}
